import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { DtoService } from '../../services/dto.service';

@Component({
  selector: 'app-pointtransfer',
  templateUrl: './pointtransfer.component.html',
  styleUrls: ['./pointtransfer.component.scss']
})
export class PointtransferComponent implements OnInit {
  modalRef?: BsModalRef;

  constructor(private cdr: ChangeDetectorRef, private spinner: NgxSpinnerService,private router: Router,
     private dto: DtoService, private modalService: BsModalService) { }

  ngOnInit(): void {
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,{
      class: "bet-edit-modal modal-sm",
      backdrop: true,
      ignoreBackdropClick: true
      });
    //this.removeBootstrap();
    this.cdr.detectChanges();
  }
  closeModal()
  {
    this.modalRef.hide();
  }
}
